import React, { useState, useEffect, useMemo } from "react";
import moment from 'moment-timezone';
import { Col, Row } from "react-bootstrap";
import Axios from "axios";
import { Popover } from 'antd';
import { Help } from '@material-ui/icons';

import { dirname } from "../../../../util/resourcePath";
import GYAxios from "../../../../util/GYAxios";

import DefaultSelect from "../../../general/DefaultSelect";
import KeycloakPanelTable from "./KeycloakPanelTable";

const KeycloakPanelContent = () => {
	const directory = dirname();
	const [reload, setReload] = useState(true);
	const [countriesSelectOptions, setCountriesSelectOptions] = useState([]);
	const [userTypeSelectOptions, setUserTypeSelectOptions] = useState([]);

	const [selectedCountry, setSelectedCountry] = useState("ALL");
	const [selectedType, setSelectedType] = useState(0);
	const [selectedExpStatus, setSelectedExpStatus] = useState("ALL");
	const [isEditable, setIsEditable] = useState(false);
	const [maxLastConnDate, setMaxLastConnDate] = useState(null);

	const [KCUsers, setKCUsers] = useState([]);
	const filteredKCUsers = useMemo(() => {
		if(!maxLastConnDate) { return KCUsers }
		return KCUsers.filter(user => (!user.last_connection && moment(maxLastConnDate).diff(moment(user.created_at).startOf('day')) >= 0) || moment(maxLastConnDate).diff(moment(user.last_connection).startOf('day')) >= 0);
	}, [KCUsers, maxLastConnDate]);

	const defaultCountrytOpt = {
		value: "ALL",
		label: "All Countries",
	};
	const defaultUserTypeOpt = {
		value: 0,
		label: "All Users",
	};

	const exportedStatusOptions = [
		{
			value: "ALL",
			label: "All Users",
		},
		{
			value: 1,
			label: "Exported",
		},
		{
			value: 0,
			label: "Not Exported",
		},
	];

	/**
	 * Fetch countries select
	 */
	const fetchCountries = () => {
		GYAxios.get("/select/countries").then((res) => {
			const countries = !res.data.error ? res.data : [];
			setCountriesSelectOptions(countries);
		});
	};

	/**
	 * Fetch countries select
	 */
	const fetchUserTypes = () => {
		GYAxios.get("/select/user/type").then((res) => {
			const userType = !res.data.error ? res.data : [];
			setUserTypeSelectOptions(userType);
		});
	};

	/**
	 * Fetch users based on filter selected
	 * @param {string} selectedCountry
	 * @param {string} selectedType
	 * @param {string} selectedExpStatus
	 */
	const fetchUsers = (selectedCountry, selectedType, selectedExpStatus) => {
		const countryFilter =
			selectedCountry != "ALL" ? `country=${selectedCountry}` : `country=all`;
		const typeFilter = selectedType != 0 ? `type=${selectedType}` : `type=all`;
		const expStatusFilter =
			selectedExpStatus != "ALL"
				? `column=exported_status&value=${selectedExpStatus}`
				: `column=exported_status&value=all`;

		const userURI = `/users/filter?${countryFilter}&${typeFilter}&${expStatusFilter}`;

		GYAxios.get(userURI).then((res) => {
			const users = res.data.error == null ? res.data : [];

			setKCUsers(users);
			setReload(false);
		});
	};

	useEffect(() => {
		fetchCountries();
		fetchUserTypes();
	}, []);

	useEffect(() => {
		const notExportedSelected = selectedExpStatus == 0;
		setIsEditable(notExportedSelected);
	}, [selectedExpStatus]);

	useEffect(() => {
		if (reload) fetchUsers(selectedCountry, selectedType, selectedExpStatus);
	}, [selectedCountry, selectedType, selectedExpStatus, reload]);

	return (
		<div className="perf-table panel panel-default">
			<div className="panel-heading ">
				<Row>
					<Col sm="7" md="7" lg="7">
						<h2 className="panel-title">Keycloak Panel</h2>
					</Col>
					<Col sm="5" md="5" lg="5" style={{ textAlign: "right" }}>
						<img
							src={`${directory}/images/reload.png`}
							onClick={() => setReload(true)}
							style={{
								height: "35px",
								cursor: "pointer",
							}}
							alt="logo"
						/>
					</Col>
				</Row>
				<Row>
					<Col md="2">
						<label>Country Select</label>
						<DefaultSelect
							options={countriesSelectOptions}
							defaultValue={defaultCountrytOpt}
							onChange={(e) => {
								setSelectedCountry(e.value);
								setReload(true);
							}}
							isDefault={true}
						/>
					</Col>
					<Col md="2">
						<label>User Type Select</label>
						<DefaultSelect
							options={userTypeSelectOptions}
							defaultValue={defaultUserTypeOpt}
							onChange={(e) => {
								setSelectedType(e.value);
								setReload(true);
							}}
							isDefault={true}
						/>
					</Col>
					<Col md="2">
						<label>User Exported Status</label>
						<DefaultSelect
							options={exportedStatusOptions}
							defaultValue={exportedStatusOptions[0]}
							onChange={(e) => {
								setSelectedExpStatus(e.value);
								setReload(true);
							}}
							isDefault={true}
						/>
					</Col>
					<Col md="2">
						<label>Last Active Older Than</label>
						<Popover content="Last Active is last connection (or created_at if there is no last connection)">
							<Help style={{ marginLeft: '10px' }} />
						</Popover>
						<input type="date" value={maxLastConnDate} onChange={e => setMaxLastConnDate(e.target.value)} style={{ height: '3.1em', border: 'none', borderRadius: '5px', color: 'black', padding: '1em', width: '150px' }}></input>
					</Col> 
				</Row>
			</div>
			<div>
				<KeycloakPanelTable
					KCUsers={filteredKCUsers}
					reload={reload}
					setReload={setReload}
					isEditable={isEditable}
				/>
			</div>
		</div>
	);
};

export default KeycloakPanelContent;
